module.exports = JSON.parse("{\"timestamp\":\"17.10.2026 - 22:25:15\",\"brands\":[]}")